import { IconProps } from 'types/icon.type'

export const PayPalIcon = (props: IconProps) => {
  return (
    <svg
      width="55"
      height="32"
      viewBox="0 0 55 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>PayPal Logo</title>
      <rect x="0.5" width="54" height="32" rx="6" fill="white" />
      <path
        d="M33.9183 11.8272C33.9008 11.9399 33.8808 12.0551 33.8583 12.1735C33.0844 16.1722 30.4371 17.5536 27.0558 17.5536H25.3342C24.9208 17.5536 24.5723 17.8558 24.5079 18.2663L23.6264 23.8927L23.3768 25.4874C23.3348 25.757 23.5414 26 23.8115 26H26.8651C27.2267 26 27.5337 25.7356 27.5906 25.3767L27.6207 25.2205L28.1956 21.5485L28.2326 21.3471C28.2887 20.987 28.5965 20.7226 28.9581 20.7226H29.4148C32.3731 20.7226 34.689 19.5137 35.3659 16.0154C35.6487 14.5541 35.5022 13.3339 34.754 12.4757C34.5277 12.2169 34.2468 12.0022 33.9183 11.8272Z"
        fill="#179BD7"
      />
      <path
        d="M33.1085 11.5026C32.9904 11.4679 32.8683 11.4364 32.7431 11.4081C32.6174 11.3804 32.4885 11.3559 32.356 11.3345C31.8917 11.2589 31.3832 11.223 30.8383 11.223H26.2391C26.1258 11.223 26.0183 11.2488 25.922 11.2954C25.7099 11.398 25.5523 11.6002 25.5141 11.8476L24.5356 18.0846L24.5079 18.2663C24.5723 17.8558 24.9208 17.5536 25.3342 17.5536H27.0558C30.4371 17.5536 33.0844 16.1722 33.8583 12.1735C33.8808 12.0551 33.9008 11.9399 33.9183 11.8272C33.7226 11.7227 33.5101 11.6335 33.2817 11.5573C33.2255 11.5384 33.1674 11.5202 33.1085 11.5026Z"
        fill="#222D65"
      />
      <path
        d="M25.5141 11.8476C25.5523 11.6002 25.7099 11.398 25.922 11.2954C26.0183 11.2488 26.1258 11.223 26.2391 11.223H30.8383C31.3832 11.223 31.8917 11.2589 32.356 11.3345C32.4885 11.3559 32.6174 11.3804 32.7431 11.4081C32.8683 11.4364 32.9904 11.4679 33.1085 11.5026C33.1672 11.5202 33.2248 11.5391 33.2817 11.5573C33.5101 11.6335 33.7226 11.7227 33.9183 11.8272C34.1486 10.3494 33.9169 9.34345 33.1231 8.43238C32.2479 7.4294 30.6683 7 28.6471 7H22.7792C22.3662 7 22.0142 7.3022 21.9503 7.71335L19.5063 23.306C19.458 23.6144 19.6945 23.8928 20.0035 23.8928L23.6264 23.8927L24.5356 18.0846L25.5141 11.8476Z"
        fill="#253B80"
      />
    </svg>
  )
}
